import { useState } from 'react'
import { signOut } from '../lib/auth'
import { t } from '../lib/i18n'

/** A failed device revocation must stay visible and retryable before logout. */
export default function SignOut({ onSignedOut }: { onSignedOut: () => void | Promise<void> }) {
  const [busy, setBusy] = useState(false)
  const [failed, setFailed] = useState(false)
  async function leave() {
    setBusy(true)
    setFailed(false)
    try {
      await signOut()
      await onSignedOut()
    } catch {
      setFailed(true)
    } finally {
      setBusy(false)
    }
  }
  return <>
    <button className="w-signout" disabled={busy} onClick={() => { void leave() }}>{t('app.signOut')}</button>
    {failed && <p className="error" role="alert">{t('notify.logoutRetry')}</p>}
  </>
}
